//https://codepen.io/JayG_99/pen/LYNMNxw
import $ from 'jquery'

$(function() {
	const dispatchCalendarInitialization = ($profileElement) => {
		if (!$profileElement || $profileElement.length === 0) return
		const container = $profileElement.find('.card-body-parent.collapse').get(0)
      || $profileElement.find('.submenu').get(0)
		if (!container || typeof document === 'undefined') return

		try {
			document.dispatchEvent(new CustomEvent('pignose:initialize', { detail: { container } }))
		} catch (error) {
			if (typeof document.createEvent === 'function') {
				const fallbackEvent = document.createEvent('CustomEvent')
				fallbackEvent.initCustomEvent('pignose:initialize', true, true, { container })
				document.dispatchEvent(fallbackEvent)
			}
		}
	}

	let CustomAccordion = function(el, multiple) {
		this.el = el || {};
		this.multiple = multiple || false;

		// Variables privadas
		let links = this.el.find('.link');
		// Evento
		links.on('click', {el: this.el, multiple: this.multiple}, this.dropdown)
	}

	CustomAccordion.prototype.dropdown = function(e) {
		const $el = e.data.el;
		const $trigger = $(this);
		if (!e.data.multiple) {
			const parentLiElement = $trigger.closest('.profile-page');
			$el.find('.profile-page.active').not(parentLiElement).each(function(index, htmlElement){
				const $htmlElement = $(htmlElement);
				$htmlElement.removeClass('active');
				const $subMenuElement = $htmlElement.find('.submenu');
				$subMenuElement.slideUp("slow").addClass('d-none').find('.card-body-parent.collapse').removeClass('show');
				//$subMenuElement.next().removeClass('align-to-right').find('.panel-collapsor').removeClass('btn-secondary opacity-30-percent').html('Continue');
				$htmlElement.find('.panel-collapsor').removeClass('btn-secondary opacity-30-percent width-10').html('Continue');
			});
		};
		const activeProfileElement = $trigger.closest('.profile-page');
		if(activeProfileElement.hasClass("active")){
			$trigger.removeClass('btn-secondary opacity-30-percent width-10').html('Continue');
			const $next = activeProfileElement.find('.submenu');
			$next.slideUp("slow");
			$next.addClass('d-none').find('.card-body-parent.collapse').removeClass('show');
			activeProfileElement.removeClass('active');
		} else {
			//$next = $this.parent().parent().parent().parent().find('.size-price-right').addClass('align-to-right').parent().find('.submenu');
			const $next = activeProfileElement.find('.submenu');
			$next.slideDown("slow");
			$trigger.addClass('btn-secondary opacity-30-percent width-10').html('<i style="font-size:20px" class="fa">&#xf00d;</i>');
			$next.removeClass('d-none').find('.card-body-parent.collapse').addClass('show');
			activeProfileElement.addClass('active');
			const reservationFormID = $trigger.attr('id').split('-', 2)[1];
      		const divElement = document.getElementById("li-"+reservationFormID);
      		divElement.scrollIntoView({behavior: "smooth", block: "start", inline: "end"});
			dispatchCalendarInitialization(activeProfileElement);
		}
	}

	let accordion = new CustomAccordion($('#facilities-accordion-ul'), false);

	// To open the successful reservation booking modal
	if($('.open-reservation-modal').length > 0){
		$('.open-reservation-modal').trigger('click');
	}
});
